import React from 'react';
import './Footer.css';
import ubicacionIcon from '../assets/icons/ubicacion-icon.svg';
import telfIcon from '../assets/icons/telefono-icon.svg';
import emailIcon from '../assets/icons/email-icon.svg';
import fbIcon from '../assets/icons/fb-icon.svg'
import igIcon from '../assets/icons/ig-icon.svg'
import twIcon from '../assets/icons/tw-icon.svg'
import ytIcon from '../assets/icons/yt-icon.svg'
import catFlag from '../assets/icons/cat-flag-icon.svg'
import esFlag from '../assets/icons/esp-flag-icon.svg'
import ukFlag from '../assets/icons/uk-flag-icon.svg'
import { t } from 'i18next';
import i18n from '../i18n';



function Footer(props) {


    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    }


    return (
        <div className='footer-container'>
            <div className='info-subcontainer'>
                <h3 style={{ marginBottom: '10px' }}>RIPOLLÈS ASSESSORS</h3>
                <div className='footer-row'><img className='footer-icons' src={ubicacionIcon} alt="Icono dirección" /><a className='Link a link-footer footer-row ' target="_blank" href="https://www.google.es/maps/place/Ripoll%C3%A8s+Assessors+-+Ripoll/@42.193789,2.192897,17z/data=!3m1!4b1!4m6!3m5!1s0x12a53f73d1b3c79f:0x288cb39246e2ff1a!8m2!3d42.193789!4d2.192897!16s%2Fg%2F1q5bm577y?hl=es-419&entry=ttu&g_ep=EgoyMDI0MTEyNC4xIKXMDSoASAFQAw%3D%3D">Carretera de Barcelona, 27 baixos - 17500 Ripoll</a></div>
                <div className='footer-row'><img className='footer-icons' src={telfIcon} alt="Icono teléfono" /><a className='Link a link-footer footer-row ' href="tel:972 701 385">972 701 385</a></div>
                <div className='footer-row'><img className='footer-icons' src={emailIcon} alt="Icono email" /><a className='Link a link-footer footer-row ' href="mailto:info@garrotxtaactiva.cat">info@ripollesassessors.cat</a></div>

            </div>
            <div className='info-subcontainer'>
                <h3 style={{ marginBottom: '10px' }}>{t("ENLLAÇOS D'INTERÈS")}</h3>
                <div className='footer-row'><a className='Link a link-footer footer-row' href="/serveis/">{t("Presentació")}</a></div>
                <div className='footer-row'><a className='Link a link-footer footer-row' href="/">{t("Cercar immoble")}</a></div>
                <div className='footer-row'><a className='Link a link-footer footer-row' href="/vendre/">{t("Vendre | Llogar")}</a></div>
                <div className='footer-row'><a className='Link a link-footer footer-row' href="/blog/">{t("Blog")}</a></div>
            </div>
            <div className='info-subcontainer' >
                <h3 style={{ marginBottom: '10px' }}>{t("LEGAL")}</h3>
                <div className='footer-row'> <a className='Link a link-footer footer-row' href="/politica-privacitat/">{t("Política de Privacitat")}</a></div>
                <div className='footer-row'> <a className='Link a link-footer footer-row' href="/politica-cookies/">{t("Política de Cookies")}</a></div>
                <div className='footer-row'> <a className='Link a link-footer footer-row' href="/avis-legal/">{t("Avís legal")}</a></div>

            </div>
            <div className='info-subcontainer'>
                <h3 style={{ marginBottom: '10px' }}>{t("SEGUEIX-NOS")}</h3>
                <div className='footer-icons-row'>
                    {/* <a className='Link a link-footer' href="https://es-es.facebook.com/GarrotxaActiva/">
                        <img style={{ height: 25 }} className='icon-upper-nav' src={fbIcon} alt='Icono Facebook' />
                    </a> */}
                    <a className='Link a link-footer' href="https://www.instagram.com/ripollesassessors/">
                        <img style={{ height: 25 }} className='icon-upper-nav' src={igIcon} alt='Icono Instagram' />
                    </a>
                    {/* <a className='Link a link-footer' href="https://twitter.com/garrotxaactiva">
                        <img style={{ height: 25 }} className='icon-upper-nav' src={twIcon} alt='Icono Twitter' />
                    </a>
                    <a className='Link a link-footer' href="https://www.youtube.com/channel/UCduIKGnL0S6p3ay-bhRueyg">
                        <img style={{ height: 25 }} className='icon-upper-nav' src={ytIcon} alt='Icono Youtube' />
                    </a> */}
                </div>
            </div>
            <div id='idioma-subcontainer' className='info-subcontainer'>
                <h3 style={{ marginBottom: '10px' }}>{t("IDIOMA")}</h3>
                <div className='footer-icons-row'>
                    <div onClick={() => changeLanguage('ca')} className='link-footer' >
                        <img style={{ height: 25 }} className='icon-upper-nav' src={catFlag} alt='Icono Idioma Catalán' />
                    </div>
                    <div onClick={() => changeLanguage('es')} className='link-footer'>
                        <img style={{ height: 25 }} className='icon-upper-nav' src={esFlag} alt='Icono Idioma Español' />
                    </div>
                    {/* <div onClick={() => changeLanguage('en')} className='link-footer' >
                        <img style={{ height: 25 }} className='icon-upper-nav' src={ukFlag} alt='tw-icon' />
                    </div> */}

                </div>
            </div>
        </div>
    );
}

export default Footer;